import { Box } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { TaskOverlayBody } from 'components/TaskOverlay';
import { IntermediateStepTaskOverlay } from 'components/TaskOverlay/IntermediateStepTaskOverlay';
import { lazy } from '@loadable/component';
import { SuspendWithSpinner } from 'components/SuspendWithSpinner';

const RemirrorRenderer = lazy(() => import('components/Editor/Renderer'));

interface PageTemplatePreviewModalProps {
  templateContent: string;
  templateName: string;
  onClose: () => void;
  isOpen: boolean;
  onUseTemplate(content: string): void;
}

export const PageTemplatePreviewModal = ({
  templateContent,
  isOpen,
  templateName,
  onClose,
  onUseTemplate,
}: PageTemplatePreviewModalProps) => {
  return (
    <IntermediateStepTaskOverlay
      title={t`Preview Template`}
      isOpen={isOpen}
      onClose={onClose}
      submitButtonTitle={t`Use`}
      onCompleteTask={() => {
        onClose();
        onUseTemplate(templateContent);
      }}
    >
      <TaskOverlayBody>
        <Box>
          <SuspendWithSpinner>
            <RemirrorRenderer json={templateContent} />
          </SuspendWithSpinner>
        </Box>
      </TaskOverlayBody>
    </IntermediateStepTaskOverlay>
  );
};
